/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line @typescript-eslint/no-var-requires
// eslint-disable-next-line no-undef
require('dotenv').config();

// eslint-disable-next-line no-undef
export const BG_SERVICE = process.env.REACT_APP_BACKEND;
